import React, { useState } from 'react';
import { __, __route } from 'localisation';
import { formatMoney } from 'helpers';
import Button from '@hubins/components/Button';
import { LoadingBar } from 'components/LoadingIndicators';

import Badge from '@hubins/components/Badge';
import EventCard from 'modules/EventCard';
import Heading from 'components/Heading';

const PayCard = ({
  data = {},
  deleteTradeOrder,
  portfolio,
  backoffice,
  ...restProps
}) => {
  const [loading, setLoading] = useState(false);

  const policyHolder = portfolio.policy_holder[0];
  const isCompany = policyHolder && policyHolder.type === 'COMPANY';

  const sofCheck = () => {

    let done = false;
    let upload = false;
    let needed = false;

    if (data.orderStatus === '10') {
      return {
        done,
        upload,
        needed,
      };
    }

    const sofTag = 'SourceOfFunds';
    const tags = data['tags'];
    done = tags.includes(`${sofTag}-done`);
    upload = tags.includes(`${sofTag}-upload`);
    needed = tags.includes(`${sofTag}-needed`);

    return {
      done,
      upload,
      needed,
    };
  };

  const { done, upload, needed } = sofCheck();

  const sofRoute = isCompany ? 'companySof' : 'sof';
  const pofRoute = isCompany ? 'companySofdoc' : 'sofdoc';

  return (
    <EventCard
      {...restProps}
      className="s-bottom-m"
      text={data.eventCard ? __(data.eventCard.text) : false}
      thumbnail={false}
      cardtype="PayCard"
      alt={__('payment')}
      meta={
        data.type.typeCode
          ? `${__('premium')} - ${data.transactionDate}`
          : <LoadingBar medium />
      }
      status={<Badge color={data.eventCard.color}>{__(data.eventCard.title)}</Badge>}
      header={
        <>
          <Heading element="h3" size="4">{formatMoney(data.amount, data.currencyCode || 'SEK')}</Heading>

          <p className="clarification">
            {__(data.eventCard.text)}
            {(upload || needed) && (
              <>
                .<br /> {__('sof_needed_upload')}
              </>
            )}
            {done && (
              <>
                .<br /> {__('sof_done')}
              </>
            )}
            {import.meta.env.MODE === 'development' && <><br />{data.security ? data.security.name : ''}</>}
          </p>
          {!backoffice && (
            <div className="button__wrap button__wrap--end">
              {data.orderStatus !== '5' && (
                <Button
                  className="small"
                  loading={loading}
                  icon="Bin by Streamlinehq"
                  onClick={() => {
                    setLoading(true);
                    deleteTradeOrder({
                      'o.extId': data.extId,
                      'o.id': data.id,
                    });
                  }}>
                  {__('abort_premium')}
                </Button>
              )}
              {(upload || needed) ? (
                <>
                  {(upload || needed) && (
                    <Button
                      className="cta small"
                      href={
                        `${__route(
                          needed
                            ? `${sofRoute}`
                            : `${pofRoute}`
                        )}/${data.id}/${data.extId}/${portfolio.uuid}`
                      }>
                      {__('declare_now')}
                    </Button>
                  )}
                </>
              ) : (
                <>
                  {(data.orderStatus === '10') && (
                    <Button className="cta small"
                      href={`${__route('depositInstructions')}/q/${portfolio.uuid}/${data.id}`}
                      icon="Download Dash Arrow 1"
                      iconColor='white'
                      iconLeft
                    >
                      {__('pay')}
                    </Button>
                  )}
                </>
              )}
            </div>
          )}
        </>
      }
    />

  );
};



export default PayCard;
